import React from 'react'

//@ts-ignore
import styles from './ViewerCloseButton.module.css'

export interface ViewerCloseButtonProps {
  onClick: () => void
}

// The one X for the Job Summary product viewer, whatever tab is open.
const ViewerCloseButton = React.forwardRef<
  HTMLButtonElement,
  ViewerCloseButtonProps
>(function ViewerCloseButton({ onClick }, ref) {
  return (
    <button
      aria-label="Close"
      className={styles['close']}
      onClick={onClick}
      ref={ref}
      type="button"
    >
      ×
    </button>
  )
})

export default ViewerCloseButton
